import { useEffect, useState } from "react";
import { ContainerWithNavBar } from "../Gamification/shared/ContainerWithNavBar";
import { Box, Paper } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import { ButtonCustom, defaultMaterialTheme } from "../shared/Style/Style";
import {
  AddVersions,
  MobileVersionInfo,
  MobileVersionList,
} from "../MobileVersions/MobileVersions.style";
import { convertDateAndTimeToLocaleHandler } from "../shared/Utils/ConvertOperations/convertDateAndTimeToLocaleHandler";
import { useParams } from "react-router-dom";
import {
  CreateApplicationVersionDocument,
  CreateApplicationVersionMutation,
  GetApplicationVersionsDocument,
  Os,
  useGetApplicationVersionsQuery,
} from "../../generated/graphql";
import { useMutation } from "@apollo/client";
import { ErrorMessageSnackbar } from "../shared/ErrorMessageSnackbar";

export const VrVersions = () => {
  const { appId } = useParams<{ appId: string }>();
  const [vrVersion, setVrVersion] = useState("");

  const [requestError, setRequestError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const { data, loading } = useGetApplicationVersionsQuery({
    variables: {
      appId,
    },
  });

  const [
    createMobileVersion,
    { data: createMobileVersionData, loading: createMobileVersionLoading },
  ] = useMutation<CreateApplicationVersionMutation>(
    CreateApplicationVersionDocument,
    {
      variables: { appId },
      refetchQueries: [GetApplicationVersionsDocument],
    }
  );

  const errorHandler = (message: string) => {
    setRequestError(true);
    setErrorMessage(message);
  };

  const createVersionHandle = async (type: Os) => {
    try {
      if (!vrVersion) {
        return;
      }

      await createMobileVersion({
        variables: {
          os: type,
          version: vrVersion,
        },
      });
    } catch (e) {
      errorHandler("При збереженні версії виникла помилка");
    }
  };

  useEffect(() => {
    if (createMobileVersionData?.createApplicationVersion.os === Os.Vr) {
      setVrVersion("");
    }
  }, [createMobileVersionData]);

  const disableOnLoading = loading || createMobileVersionLoading;
  const versionsData = data?.getApplicationVersions ?? [];
  const versionsVR = versionsData.filter((version) => version.os === Os.Vr);

  return (
    <>
      <ContainerWithNavBar header="VR Версії">
        <Paper elevation={4}>
          <ThemeProvider theme={defaultMaterialTheme}>
            <Box
              p="60px 0 120px 0"
              display="flex"
              flexDirection="column"
              alignItems="center"
            >
              <h2 style={{ marginBottom: 16 }}>Версії для VR</h2>

              <Box display="flex" width="400px" mb={3}>
                <AddVersions
                  value={vrVersion}
                  label="Введіть версію"
                  multiline
                  fullWidth
                  onChange={({ target: { value } }) => setVrVersion(value)}
                />
                <ButtonCustom
                  disabled={disableOnLoading}
                  onClick={() => createVersionHandle(Os.Vr)}
                >
                  Зберегти
                </ButtonCustom>
              </Box>

              {versionsVR.length > 0 && (
                <MobileVersionList>
                  <Box mt={2} display="flex" justifyContent="center">
                    <MobileVersionInfo>
                      {versionsVR[0].version}
                    </MobileVersionInfo>
                    <MobileVersionInfo>
                      {convertDateAndTimeToLocaleHandler(
                        versionsVR[0].createdDate
                      )}
                    </MobileVersionInfo>
                  </Box>
                </MobileVersionList>
              )}

              <Box display="flex" justifyContent="center">
                <h2>Історія оновлень VR</h2>
              </Box>
              <Box width="400px">
                {versionsVR.map((item) => (
                  <MobileVersionList key={item.id}>
                    <Box mt={2} display="flex" justifyContent="space-between">
                      <MobileVersionInfo>{item.version}</MobileVersionInfo>
                      <MobileVersionInfo>
                        {convertDateAndTimeToLocaleHandler(item.createdDate)}
                      </MobileVersionInfo>
                    </Box>
                  </MobileVersionList>
                ))}
              </Box>
            </Box>
          </ThemeProvider>
        </Paper>
      </ContainerWithNavBar>
      {requestError && (
        <ErrorMessageSnackbar
          open={requestError}
          closeHandler={() => setRequestError(false)}
          message={errorMessage}
        />
      )}
    </>
  );
};
